import { combineReducers } from "redux";
import isloged  from "./isloged";

const store = combineReducers({
   login: isloged
})

export default store;